import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getSrtSecrets } from "./actions";

export const srtSecretsEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity._id,
});

const initialState = srtSecretsEntityAdapter.getInitialState({
  totalCount: 0,
});

export const srtSecretsSlice = createSlice({
  name: "srtSecrets",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSrtSecrets.fulfilled, (state, action) => {
      if (action.payload.success) {
        srtSecretsEntityAdapter.setAll(state, action.payload.data);
        state.totalCount = action.payload.srtSecretsCount;
      }
    });
  },
});

export default srtSecretsSlice.reducer;
